import {
  HStack,
  Image,
  StackProps,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import { NavItemInterface, publicMenu } from "../../constants/sidebarList";
import { useBgHover } from "../../themes/colors";
import LoginModal from "../modal/LoginModal";

interface Props extends StackProps {
  onClose: () => void;
}

export const DrawerNoAuth = ({ onClose, ...rest }: Props) => {
  const {
    isOpen: isOpenLogin,
    onOpen: onOpenLogin,
    onClose: onCloseLogin,
  } = useDisclosure();

  const bgHover = useBgHover();
  const navigate = useNavigate();

  const handleNavigation = (navItem: NavItemInterface) => {
    if (navItem.href) {
      navigate(navItem.href);
      window.scrollTo(0, 0);
      onClose();
    } else {
      onOpenLogin();
    }
  };

  const goToMain = () => {
    navigate("/");
    onClose();
  };

  return (
    <>
      <VStack gap={0} cursor={"pointer"} onClick={goToMain} {...rest}>
        <Image
          src={logo}
          objectFit={"contain"}
          w={"80px"}
          h={"80px"}
          rounded={"full"}
          mx={"auto"}
          mt={"51px"}
        />
        <Text textAlign={"center"} textStyle={"h-title"} mt={"14px"}>
          Bisnis Link
        </Text>
      </VStack>

      <VStack gap={"14px"} mt={6} px={4} align={"stretch"}>
        {publicMenu.map((navItem, index) => (
          <HStack
            key={index}
            p={2}
            borderRadius={"md"}
            cursor={"pointer"}
            onClick={() => handleNavigation(navItem)}
            _hover={{ bg: bgHover }}
          >
            <Text
              w={"fit-content"}
              textAlign={"start"}
              textStyle={"h-subtitle"}
              fontWeight={"semibold"}
            >
              {navItem.label}
            </Text>
          </HStack>
        ))}
      </VStack>

      <LoginModal
        isOpen={isOpenLogin}
        onOpen={onOpenLogin}
        onClose={onCloseLogin}
        children={undefined}
      />
    </>
  );
};
